import _ from 'lodash';
/**
 * Created by zoechodosh on 1/17/17.
 */
export const TravelTypes = [
  {
    title: 'Hotel',
    value: 'HOTEL',
    fields: {
      name: { label: 'Hotel Name' },
      address: { label: 'Hotel Name or Address' },
      contactNumber: { label: 'Hotel Phone Number' },
      url: { label: 'Hotel Website Address' },
      code: { label: 'Discount Code', placeholder: 'LOVE1' },
      note: { placeholder: 'This is where we’ll be having our rehearsal dinner and welcome drinks. And it’s not far from our ceremony, either. To book, don\'t forget to use our discount code.' }
    }
  },
  {
    title: 'House Or Rental',
    value: 'HOME_RENTAL',
    fields: {
      name: { label: 'House Or Rental Name' },
      address: { label: 'House Or Rental Name or Address' },
      contactNumber: { label: 'House Or Rental Phone Number' },
      url: { label: 'House Or Rental Website Address' },
      note: { placeholder: 'We rented this 12-bedroom house on Airbnb for the wedding weekend. It has private beach access, a pool table, a home movie theater, workout room, hot tub, pool, and helipad. If you’d like to stay here, reach out to the Maid of Honor, Alyssa, at alyssa@email.com.' }
    }
  },
  {
    title: 'Flight',
    value: 'FLIGHT',
    fields: {
      name: { label: 'Airport, Airline or Flight Name' },
      url: { label: 'Website Address' },
      code: { label: 'Discount Code' },
      note: { placeholder: 'NYC has tons of airports, but Laguardia is definitely the easiest for domestic flights and is only a short car ride from all hotel and rental suggestions.' }
    }
  },
  {
    title: 'Rental Car',
    value: 'CAR_RENTAL',
    fields: {
      name: { label: 'Rental Car Company Name' },
      address: { label: 'Rental Car Company Name or Address' },
      url: { label: 'Rental Car Company Website Address' },
      contactNumber: { label: 'Rental Car Company Phone' },
      note: { placeholder: 'Our friend set us up with a 15% discount for all of our guests. Enter our name in the promo code section or mention it on the phone when you book.' }
    }
  },
  {
    title: 'Shuttle',
    value: 'SHUTTLE',
    fields: {
      name: { label: 'Shuttle Name', placeholder: 'Shuttle From The Main Hotel To The Ceremony' },
      note: { placeholder: 'A shuttle will be running every hour from the reception back to the main hotel for those who forget their dancing shoes :)' }
    }
  },
  {
    title: 'Train',
    value: 'TRAIN',
    fields: {
      name: { label: 'Train Name' },
      url: { label: 'Train Website Address' },
      code: { label: 'Discount Code' },
      note: { placeholder: 'We\'ve taken Amtrak several times—a great option for those traveling to NYC from DC or Boston areas.' }
    }
  },
  {
    title: 'Travel Note',
    value: 'NOTE',
    fields: {
      name: { label: 'Travel Note Name', placeholder: 'Cab Information' },
      url: { label: 'Travel Note Website Address' },
      note: { placeholder: 'While some cabs are accepting credit cards, several of them refuse them, so make sure you have a little bit of cash on hand.' }
    }
  }
];

const getTravel = (type) => {
  const idx = _.findIndex(TravelTypes, elem => (elem.value === type));
  return (idx >= 0) ? TravelTypes[idx] : null;
};

export const getTravelType = (type) => {
  const travel = getTravel(type);
  return travel ? travel.title : '';
};

export const hasTravelField = (type, field) => !!getTravel(type).fields[field];

export const getTravelFieldLabel = (type, field) => {
  const travel = getTravel(type);
  return travel.fields[field].label;
};

export const getTravelFieldPlaceholder = (type, field) => {
  const travel = getTravel(type);
  return travel.fields[field].placeholder || '';
};



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/TravelTypes.js
 **/